import React from 'react';

/**
 * Hook that returns the previous value of a variable from the last render
 *
 * @template T The type of the value to track
 * @param value - The current value to track
 * @param defaultValue - The default value to use or defaults to undefined
 * @returns The previous value from the last render
 */
const usePrevious = <T>(value: T, defaultValue?: T) => {
  const ref = React.useRef<T | undefined>(defaultValue);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
